// hiskeyId of publication access type = "open access"
export const OPEN_ACCESS = 4;
// is peer reviewed
export const PEER_REVIEWED_HISKEY_ID = 1001;
//peer-reviewed=nein
export const NO_PEER_REVIEW_HISKEY_ID =1002;

// hiskeyIds of publication creator types that are editors
export const PUBLICATION_CREATOR_TYPE_EDITORS: number[] = [2, 4, 6];
// hiskeyId of qualification thesis type = "not applicable"
export const NONE_QUALIFICATION_THESIS = 3;

// key for data service or calls
export const DATA_SERVICE_KEY_PARENT_PUBLICATION = 'parentPublication';
export const DATA_SERVICE_KEY_CHILD_PUBLICATION = 'childPublication';
export const DATA_SERVICE_KEY_PUBLICATION = 'publication';
export const DATA_SERVICE_KEY_REASEARCH_ACTIVITY = 'researchActivity';
export const DATA_SERVICE_KEY_JOURNAL = 'journal';
export const DATA_SERVICE_KEY_PUBLISHER = 'publisher';
export const DATA_SERVICE_KEY_CONFERENCE = 'conference';

export const CREATOR_EDIT = 'creatorEdit';
export const CREATOR_ADD = 'creatorAdd';
export const CREATOR_KEY = 'creatorKey';
export const ORIGINAL_CREATOR_KEY = 'originalCreator';

export const INTERFACE_TYPE_BIBTEX = 'bibtex';
export const INTERFACE_TYPE_RIS = 'ris';
export const INTERFACE_TYPE_ORCID = 'orcid';
export const INTERFACE_TYPE_EXCEL = 'excel';
export const INTERFACE_TYPE_WOS = 'wos';

// used to display arbitrary notifications on subsequent pages
export const NOTIFICATION = 'notification';
